import { Grid, GridProps } from "@chakra-ui/react";

type SubgridLayoutProps<COL extends string, ROW extends string> = {
  columns: Cells<COL>;
  rows: Cells<ROW>;
} & GridProps;
export function SubgridLayout<COL extends string, ROW extends string>({
  children,
  columns,
  rows,
  ...gridProps
}: SubgridLayoutProps<COL, ROW>) {
  const gridTemplateColumns = columns.reduce((previous, column) => {
    return previous + `[${column[0]}] ${column[1]}`;
  }, "");
  const gridTemplateRows = rows.reduce((previous, row) => {
    return previous + `[${row[0]}] ${row[1]}`;
  }, "");
  return (
    <Grid
      gridTemplateColumns={gridTemplateColumns}
      gridTemplateRows={gridTemplateRows}
      {...gridProps}
    >
      {children}
    </Grid>
  );
}

export const Subgrid: React.FC<GridProps> = ({ children, ...gridProps }) => {
  return (
    <Grid gridRow="span 3" gridTemplateRows="subgrid" {...gridProps}>
      {children}
    </Grid>
  );
};

type Cell<T> = [T, "auto" | "1fr" | (string & {})];
type Cells<T> =
  | [Cell<T>]
  | [Cell<T>, Cell<T>]
  | [Cell<T>, Cell<T>, Cell<T>]
  | [Cell<T>, Cell<T>, Cell<T>, Cell<T>];
